import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

/*
 * Default set of Material Icons does not include their Area Chart svg icon.
 * They provide SvgIcon component to use their other icons not included in the base set.
 */
function AreaChartIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <rect fill="none" height="24" width="24" />
      <path d="M3,13v7h18v-1.5l-9-7L8,17L3,13z M3,7l4,3l5-7l5,4h4v8.97l-9.4-7.31l-3.98,5.48L3,10.44V7z" />
    </SvgIcon>
  );
}

export default AreaChartIcon;
